import _ from 'lodash';
import Api from '../../../services/api.js';
import DataProvider from '../../../app/data-framework/data-provider';
import DataService from './data-secure.service';
import UtilsService from "../../../services/utils.service";

// these functions were originally copied from filter.model.js

function convertFilterGroupToString(filterGroup, display) {
  let filterString = '';
  _.forEach(filterGroup.filters, function(filter) {
    if (!filter.value) {
      if (filter.isQuickPick || filter.isQuickStart) {
        // do nothing (empty value is valid for quick pick and quick start filters, but we want to ignore this filter)
      } else {
        return;
      }
    } else {
      if (!_.isEmpty(filterString)) {
        // in rsql ; is AND and , is OR
        filterString += filterGroup.operator === 'and' ? (display ? ' and ' : ';') : (display ? ' or ' : ',');
      }
      filterString += display ? (filter.text || filter.shortText) : '(' + filter.value + ')';
    }
  });
  return filterString;
}


function convertOperator (op, type) {
  if (type === 'string') {
    return STRING_OPERATIONS.find(config => config.text.toLowerCase() === op).filterFunc;
  } else if (type === 'number') {
    return NUMBER_OPERATIONS.find(config => config.text.toLowerCase() === op).filterFunc;
  }
  return '=';
}

var filterFunctions = {

  //equal to
  "=": function _(filterVal, rowVal, rowData, filterParams) {
    return rowVal == filterVal ? true : false;
  },

  //less than
  "<": function _(filterVal, rowVal, rowData, filterParams) {
    return rowVal < filterVal ? true : false;
  },

  //less than or equal to
  "<=": function _(filterVal, rowVal, rowData, filterParams) {
    return rowVal <= filterVal ? true : false;
  },

  //greater than
  ">": function _(filterVal, rowVal, rowData, filterParams) {
    return rowVal > filterVal ? true : false;
  },

  //greater than or equal to
  ">=": function _(filterVal, rowVal, rowData, filterParams) {
    return rowVal >= filterVal ? true : false;
  },

  //not equal to
  "!=": function _(filterVal, rowVal, rowData, filterParams) {
    return rowVal != filterVal ? true : false;
  },

  "regex": function regex(filterVal, rowVal, rowData, filterParams) {

    if (typeof filterVal == "string") {
      filterVal = new RegExp(filterVal);
    }

    return filterVal.test(rowVal);
  },

  //contains the string
  "like": function like(filterVal, rowVal, rowData, filterParams) {
    if (filterVal === null || typeof filterVal === "undefined") {
      return rowVal === filterVal ? true : false;
    } else {
      if (typeof rowVal !== 'undefined' && rowVal !== null) {
        return String(rowVal).toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
      } else {
        return false;
      }
    }
  },
  "notlike": function like(filterVal, rowVal, rowData, filterParams) {
    return ! filterFunctions.like(filterVal, rowVal, rowData, filterParams);
  },

  "=i": function like(filterVal, rowVal, rowData, filterParams) {
    return filterFunctions['='](_.lowerCase(filterVal), _.lowerCase(rowVal), rowData, filterParams);
  },

  "!=i": function like(filterVal, rowVal, rowData, filterParams) {
    return filterFunctions['!='](_.lowerCase(filterVal), _.lowerCase(rowVal), rowData, filterParams);
  },

  //contains the keywords
  "keywords": function keywords(filterVal, rowVal, rowData, filterParams) {
    var keywords = filterVal.toLowerCase().split(typeof filterParams.separator === "undefined" ? " " : filterParams.separator),
        value = String(rowVal === null || typeof rowVal === "undefined" ? "" : rowVal).toLowerCase(),
        matches = [];

    keywords.forEach(function (keyword) {
      if (value.includes(keyword)) {
        matches.push(true);
      }
    });

    return filterParams.matchAll ? matches.length === keywords.length : !!matches.length;
  },

  //starts with the string
  "starts": function starts(filterVal, rowVal, rowData, filterParams) {
    if (filterVal === null || typeof filterVal === "undefined") {
      return rowVal === filterVal ? true : false;
    } else {
      if (typeof rowVal !== 'undefined' && rowVal !== null) {
        return String(rowVal).toLowerCase().startsWith(filterVal.toLowerCase());
      } else {
        return false;
      }
    }
  },

  //ends with the string
  "ends": function ends(filterVal, rowVal, rowData, filterParams) {
    if (filterVal === null || typeof filterVal === "undefined") {
      return rowVal === filterVal ? true : false;
    } else {
      if (typeof rowVal !== 'undefined' && rowVal !== null) {
        return String(rowVal).toLowerCase().endsWith(filterVal.toLowerCase());
      } else {
        return false;
      }
    }
  },

  //in array
  "in": function _in(filterVal, rowVal, rowData, filterParams) {
    if (Array.isArray(filterVal)) {
      return filterVal.length ? filterVal.indexOf(rowVal) > -1 : true;
    } else {
      console.warn("Filter Error - filter value is not an array:", filterVal);
      return false;
    }
  }
};


var STRING_OPERATIONS = [
  { text: 'contains', value: '=="*|*"', filterFunc: 'like' },
  { text: 'equals', value: '=="|"', filterFunc: '=i'  },
  { text: 'does not contain', value: '!="*|*"', filterFunc: 'notlike' },
  { text: 'does not equal', value: '!="|"', filterFunc: '!=i'  },
  { text: 'starts with', value: '=="|*"', filterFunc: 'starts'  },
  { text: 'ends with', value: '=="*|"', filterFunc: 'ends'  }
];

var LIST_OPERATIONS = [
  { text: 'contains', value: '=="*|*"' },
  { text: 'does not contain', value: '!="*|*"' }
];

var NUMBER_OPERATIONS = [
  { text: 'equals', value: '==', filterFunc: '=' },
  { text: 'does not equal', value: '!=', filterFunc: '!=' },
  { text: 'less than', value: '=lt=', filterFunc: '<' },
  { text: 'less than or equal to', value: '=le=', filterFunc: '<=' },
  { text: 'greater than', value: '=gt=', filterFunc: '>' },
  { text: 'greater than or equal to', value: '=ge=', filterFunc: '>=' }
];

const METRIC_TAG_OPERATIONS = [
  { text: 'contains', value: 'tags=="|=*|*"' },
  { text: 'equals', value: 'tags=="|=|"' },
  { text: 'does not contain', value: 'tags!="|=*|*"' },
  { text: 'does not equal', value: 'tags!="|=|"' },
  { text: 'starts with', value: 'tags=="|=|*"' },
  { text: 'ends with', value: 'tags=="|=*|"' }
];

const METRIC_TAG_LIST_OPERATIONS = [
  { text: 'in', value: 'tags=in=(|)' },
  { text: 'not in', value: 'tags=out=(|)' }
];

const METRIC_STAR_RATING_OPERATIONS = [
  { text: 'contains', value: 'tags=="|=|"' },
  { text: 'does not contain', value: 'tags!="|=|"' }
];

const STAR_FILTER_VALUES = [{id: "5", name: '★★★★★'}, {id: "4", name: '★★★★☆'},
  {id: "3", name: '★★★☆☆'}, {id: "2", name: '★★☆☆☆'}, {id: "1", name: '★☆☆☆☆'},
  {id: "0", name: '☆☆☆☆☆'}];

function parseFilters(filters, metadata) {
  let createdFilters = [];
  _.each(filters, function(filter) {
    let origFilter = filter, newFilter;
    filter = stripOuterParens(filter);

    if (filter.startsWith('tags')) {
      let tagMatches = filter.matchAll(/"([^"]*)"/g); // regex to get all values in quotes- just the value for single filters but multiple for lists
      let match = tagMatches.next();
      let tagOperator = filter.substring(4,6);

      // value 0 has quotes, value 1 does not
      newFilter = parseFilter(metadata, origFilter, match.value[1], undefined, tagOperator);
      newFilter.value = filter;
      newFilter.filterComplete = true;
      while ((match = tagMatches.next()) && match.done === false) {
        let parts = match.value[1].match(/[==|!=](.*)/);
        let value = parts[1];
        if (newFilter.type === METRIC_STAR_RATING_FILTER_KEY) {
          value = STAR_FILTER_VALUES.filter((starValue) => starValue.id === value)[0].name;
        }
        newFilter.text += ' or ' + value;
      }
      createdFilters.push(newFilter);
      return;
    }
    // } else if (filter.indexOf('",')) { // todo is there a better way to detect lists?
    //   let filters = filter.split(',');
    //   let newFilter = parseFilter(filters[0]);
    //   filters.forEach(function (current) {
    //     let split = current.split('=');
    //     let newFilter.text =
    //   });
    // } else if (filter.indexOf('";')) { // todo is there a better way to detect lists?
    //   let filters = filter.split(';');
    // }
    newFilter = parseFilter(metadata, origFilter, filter);
    newFilter.filterComplete = true;
    createdFilters.push(newFilter);
  });
  return createdFilters;
}

function parseFilter(metadata, origFilter, filterString, operation, tagOperator) {
  // break the filter into parts
  let params = filterString.match(/^(\w+)([=|!]+)("?.*"?)$/);
  let ignoreme  = params[0]; // this is the entire string
  let columnId  = params[1];
  operation = operation || params[2];
  let criteria  = params[3].replace(/^"/, '').replace(/"$/, '');
  let opName    = "equals";

  // get the metadata so we can lookup the values to use in the labels
  let nameColumn = _.find(metadata, function(col) {
    return col.id === columnId;
  });

  if (nameColumn.type === METRIC_TAG_FILTER_KEY) {
    opName = getMetricOperator(tagOperator, criteria);
    operation = METRIC_TAG_OPERATIONS.filter((operation) => operation.text = opName).value;
    criteria  = criteria.replace(/\*/g, '');
  } else if (nameColumn.type === METRIC_TAG_LIST_FILTER_KEY) {
    // todo
  } else if (nameColumn.type === METRIC_STAR_RATING_FILTER_KEY) {
    if (tagOperator === '!=') {
      opName = 'does not contain';
      operation = METRIC_STAR_RATING_OPERATIONS.filter((operation) => operation.text = opName).value;
      let valueParts = criteria.split(';');
      criteria = valueParts[0];
      valueParts = valueParts.slice(1);
      valueParts.forEach(part => parseFilters(part));
    } else {
      opName = 'contains';
      operation = METRIC_STAR_RATING_OPERATIONS.filter((operation) => operation.text = opName).value;
      let valueParts = criteria.split(',');
      criteria = valueParts[0];
      valueParts = valueParts.slice(1);
      valueParts.forEach(part => parseFilters(part));
    }
    let value = STAR_FILTER_VALUES.filter((value) => value.id === criteria);
    criteria  = value[0].name;
  } else if (nameColumn.type === LIST_FILTER_KEY) {
    if (operation.startsWith('==')) {
      let listOperation = LIST_OPERATIONS[0];
      operation = listOperation.value;
      opName = listOperation.text;
      let valueParts = criteria.split(',');
      criteria = valueParts[0];
      valueParts = valueParts.slice(1);
      valueParts.forEach(part => parseFilters(part));
    } else {
      let listOperation = LIST_OPERATIONS[1];
      operation = listOperation.value;
      opName = listOperation.text;
      let valueParts = criteria.split(';');
      criteria = valueParts[0];
      valueParts = valueParts.slice(1);
      valueParts.forEach(part => parseFilters(part));
    }
  } else if (nameColumn.type === STRING_FILTER_KEY ||
      nameColumn.type === SEMANTIC_TEXT_FILTER_KEY ||
      nameColumn.type === EVENT_LEVEL_FILTER_KEY ||
      nameColumn.type === EVENT_MESSAGE_FILTER_KEY ||
      nameColumn.type === MULTILINE_STRING_FILTER_KEY ||
      nameColumn.type === EVENT_ORIGIN_NAME_FILTER_KEY ||
      nameColumn.type === QUALITY_FILTER_KEY ||
      nameColumn.type === QUALITY_LATEST_FILTER_KEY ||
      nameColumn.type === STATUS_FILTER_KEY ||
      nameColumn.type === CALL_TYPE_FILTER_KEY ||
      nameColumn.type === ENDPOINT_DETAILS_LINK_FILTER_KEY ||
      nameColumn.type === MEETING_LINK_FILTER_KEY) {
    if (operation === "==") {
      // need to check if we have wild cards and adjust accordingly
      if (criteria.match(/^\*(.*)\*$/)) {
        criteria  = criteria.replace(/\*/g, '');
        opName    = "contains";
        operation = '=="*|*"'; // TODO: get from STRING_OPERATIONS in filter.vm.js
      }
      else if (criteria.match(/^[^*](.*)\*$/)) {
        criteria  = criteria.replace(/\*/g, '');
        opName    = "starts with";
        operation = '=="|*"'; // TODO: get from STRING_OPERATIONS in filter.vm.js
      }
      else if (criteria.match(/^\*(.*)[^*]$/)) {
        criteria  = criteria.replace(/\*/g, '');
        opName    = "ends with";
        operation = '=="*|"'; // TODO: get from STRING_OPERATIONS in filter.vm.js
      } else {
        operation = '=="|"'; // TODO: get from STRING_OPERATIONS in filter.vm.js
      }
    }
    else if (operation === "!=") {
      opName = "does not equal";
      operation = '!="|"'; // TODO: get from STRING_OPERATIONS in filter.vm.js
      // need to check if we have wild cards and adjust accordingly
      if (criteria.match(/^\*(.*)\*$/)) {
        criteria  = criteria.replace(/\*/g, '');
        opName    = "does not contain";
        operation = '!="*|*"'; // TODO: get from STRING_OPERATIONS in filter.vm.js
      }
    }
  }

  return {
    text:   nameColumn.name + " " + opName + " " + criteria,
    type:   nameColumn.type,
    value:  origFilter,
  };
}

function getMetricOperator(operation, value) {
  let opName = 'equals';
  if (operation === '==') {
    // need to check if we have wild cards and adjust accordingly
    if (value.match(/^\*(.*)\*$/)) {
      opName = 'contains';
    }
    else if (value.match(/^[^*](.*)\*$/)) {
      opName = 'starts with';
    }
    else if (value.match(/^\*(.*)[^*]$/)) {
      opName = 'ends with';
    }
  }
  else if (operation === '!=') {
    opName = 'does not equal';
    // need to check if we have wild cards and adjust accordingly
    if (value.match(/^\*(.*)\*$/)) {
      opName = "does not contain";
    }
  }
  return opName;
}

const CALLS_LINK_FILTER_KEY = 'CALLS_LINK';
const CONNECTION_FILTER_KEY = 'CONNECTION';
const DATE_FILTER_KEY = 'DATE';
const DURATION_FILTER_KEY = 'DURATION';
const SCORE_FILTER_KEY = 'SCORE';
const HOST_ADDRESS_FILTER_KEY = 'HOST_ADDRESS';
const LIST_FILTER_KEY = 'LIST';
const LINK_FILTER_KEY = 'LINK';
const MEETING_LINK_FILTER_KEY = 'MEETING_LINK';
const INTEGER_FILTER_KEY = 'INTEGER';
const NUMBER_FILTER_KEY = 'NUMBER';
const ADR_STATUS_FILTER_KEY = 'ADR_STATUS';
const BYTES_FILTER_KEY = 'BYTES';
const RAW_NUMBER_FILTER_KEY = 'RAW_NUMBER';
const MOS_FILTER_KEY = 'MOS';
const BITRATE_FILTER_KEY = 'BITRATE';
const QUALITY_PERCENTAGE_FILTER_KEY = 'QUALITY_PERCENTAGE';
const PERCENTAGE_FILTER_KEY = 'PERCENTAGE';
const STRING_FILTER_KEY = 'STRING';
const SEMANTIC_TEXT_FILTER_KEY = 'SEMANTIC_TEXT';
const EVENT_LEVEL_FILTER_KEY = 'EVENT_LEVEL';
const STREAM_TYPE_FILTER_KEY = 'STREAM_TYPE';
const EVENT_MESSAGE_FILTER_KEY = 'EVENT_MESSAGE';
const MULTILINE_STRING_FILTER_KEY = 'MULTILINE_STRING';
const EVENT_ORIGIN_NAME_FILTER_KEY = 'EVENT_ORIGIN_NAME';
const QUALITY_FILTER_KEY = 'QUALITY';
const QUALITY_LATEST_FILTER_KEY = 'QUALITY_LATEST';
const STATUS_FILTER_KEY = 'STATUS';
const CALL_TYPE_FILTER_KEY = 'CALL_TYPE';
const METRIC_TAG_FILTER_KEY = 'METRIC_TAG';
const METRIC_TAG_LIST_FILTER_KEY = 'METRIC_TAG_LIST';
const ADR_DOCUMENT_LINK_FILTER_KEY = 'ADR_DOCUMENT_LINK';
const ENDPOINT_DETAILS_LINK_FILTER_KEY = 'ENDPOINT_DETAILS_LINK';
const ENDPOINT_DETAILS_ID_LINK_FILTER_KEY = 'ENDPOINT_DETAILS_ID_LINK';
const NETWORK_LINK_FILTER_KEY = 'NETWORK_LINK';
const BUILDING_FILTER_KEY = 'BUILDING';
const STAR_RATING_FILTER_KEY = 'STAR_RATING';
const METRIC_STAR_RATING_FILTER_KEY = "METRIC_STAR_RATING";
const SYSTEM_LINK_KEY = 'SYSTEM_LINK';
const TRUNK_LINK_KEY = 'TRUNK_LINK';
const FILTER_DESCRIPTION_KEY = 'FILTER_DESCRIPTION';
const CAMERA_KEY = 'CAMERA';
const MICROPHONE_KEY = 'MICROPHONE';
const SPEAKER_KEY = 'SPEAKER';

const STRING_TYPE = 'string';
const NO_TYPE = 'none';
const LIST_TYPE = 'list';
const NUMBER_TYPE = 'number';
const METRIC_TYPE = 'metric';
const METRIC_LIST_TYPE = 'metricList';
const STAR_RATING_TYPE = 'starRating';
const METRIC_STAR_RATING_TYPE = 'metricStarRating';

const TYPE_MAP = {
    [CALLS_LINK_FILTER_KEY]: NO_TYPE,
    [CONNECTION_FILTER_KEY]: STRING_TYPE,
    [DATE_FILTER_KEY]: NO_TYPE,
    [DURATION_FILTER_KEY]: NUMBER_TYPE,
    [SCORE_FILTER_KEY]: NUMBER_TYPE,
    [HOST_ADDRESS_FILTER_KEY]: STRING_TYPE,
    [LIST_FILTER_KEY]: LIST_TYPE,
    [LINK_FILTER_KEY]: STRING_TYPE,
    [MEETING_LINK_FILTER_KEY]: STRING_TYPE,
    [INTEGER_FILTER_KEY]: NUMBER_TYPE,
    [NUMBER_FILTER_KEY]: NUMBER_TYPE,
    [ADR_STATUS_FILTER_KEY]: STRING_TYPE,
    [BYTES_FILTER_KEY]: NUMBER_TYPE,
    [RAW_NUMBER_FILTER_KEY]: NUMBER_TYPE,
    [MOS_FILTER_KEY]: NUMBER_TYPE,
    [BITRATE_FILTER_KEY]: NUMBER_TYPE,
    [QUALITY_PERCENTAGE_FILTER_KEY]: NUMBER_TYPE,
    [PERCENTAGE_FILTER_KEY]: NUMBER_TYPE,
    [STRING_FILTER_KEY]: STRING_TYPE,
    [SEMANTIC_TEXT_FILTER_KEY]: STRING_TYPE,
    [EVENT_LEVEL_FILTER_KEY]: STRING_TYPE,
    [STREAM_TYPE_FILTER_KEY]: STRING_TYPE,
    [EVENT_MESSAGE_FILTER_KEY]: STRING_TYPE,
    [MULTILINE_STRING_FILTER_KEY]: STRING_TYPE,
    [EVENT_ORIGIN_NAME_FILTER_KEY]: STRING_TYPE,
    [QUALITY_FILTER_KEY]: STRING_TYPE,
    [QUALITY_LATEST_FILTER_KEY]: STRING_TYPE,
    [STATUS_FILTER_KEY]: STRING_TYPE,
    [CALL_TYPE_FILTER_KEY]: STRING_TYPE,
    [METRIC_TAG_FILTER_KEY]: METRIC_TYPE,
    [METRIC_TAG_LIST_FILTER_KEY]: METRIC_LIST_TYPE,
    [ENDPOINT_DETAILS_LINK_FILTER_KEY]: STRING_TYPE,
    [ADR_DOCUMENT_LINK_FILTER_KEY]: STRING_TYPE,
    [ENDPOINT_DETAILS_ID_LINK_FILTER_KEY]: NUMBER_TYPE,
    [NETWORK_LINK_FILTER_KEY]: STRING_TYPE,
    [BUILDING_FILTER_KEY]: STRING_TYPE,
    [STAR_RATING_FILTER_KEY]: STAR_RATING_TYPE,
    [METRIC_STAR_RATING_FILTER_KEY]: METRIC_STAR_RATING_TYPE,
    [SYSTEM_LINK_KEY]: STRING_TYPE,
    [TRUNK_LINK_KEY]: STRING_TYPE,
    [FILTER_DESCRIPTION_KEY]: STRING_TYPE,
    [CAMERA_KEY]: STRING_TYPE,
    [MICROPHONE_KEY]: STRING_TYPE,
    [SPEAKER_KEY]: STRING_TYPE,
};

export default {
  convertOldFilters: function(filters) {
    let newFilters = filters.map(function(filter) {
      let type = TYPE_MAP[filter.type];
      let value = filter.columnId + filter.operator.replace('|', filter.criteria);
      if (type === NUMBER_TYPE) {
        value = filter.columnId + filter.operator + filter.criteria;
      } else if (type === LIST_TYPE) {
        value = '';
        filter.criteria.split(',').forEach(function(current) {
          value += filter.columnId + filter.operator.replace('|', current) + ",";
        });
        value = value.substring(value, value.length - 1);
      } else if (type === METRIC_TYPE) {
        value = filter.operator.replace('|', filter.columnId).replace('|', filter.criteria);
      } else if (type === METRIC_LIST_TYPE) {
        value = filter.operator.split('|')[0];
        filter.criteria.split(',').forEach(function(current) {
          value += '"' + filter.columnId + '=' + current + '",';
        });
        value = value.substring(value, value.length - 1); // take off last comma
        value += ')';
      }
      return {
        field: filter.columnId,
        operatorValue: filter.operator,
        text: filter.label,
        type: type,
        value: value,
        queryVar: filter.criteria
      };
    });
    return { filterGroups: [{ filters: newFilters, operator: 'and' }], operator: 'and' };
  },

  getDefaultFilterExpression: function() {
    return [{ filters: [{ id: UtilsService.generateID() }], operator: 'and', groupId: UtilsService.generateID() }];
  },

  getFilterOptionsForMetric(options, metricMetadata, excludeFilter = true) {
    let newOptions = _.map(options, option => {
      if (metricMetadata && metricMetadata.quick_pick_map && metricMetadata.quick_pick_map[option.id]) {
        option.quickPickId = metricMetadata.quick_pick_map[option.id];
      } else {
        delete option.quickPickId;
      }
      return option;
    });
    if (!metricMetadata || !metricMetadata.filter_exclude) {
      return _.filter(newOptions, function(m) { return !excludeFilter || !_.get(m, 'excludeFilter') });
    }
    return _.filter(newOptions, function(m) { return (!excludeFilter || !_.get(m, 'excludeFilter')) && !_.includes(metricMetadata.filter_exclude, m.id) });
  },

  getColumnsFromFilters: function(filters) {
    // return this.fetchTags().then((tags) => {
      let columns = [];
      filters.forEach(function(filter) {
        let column = {
          title: filter.name || filter.label, // todo normalize on one
          field: filter.id || filter.value, // todo normalize on one
          filterType: TYPE_MAP[filter.type],
          type: filter.type,
        };
        if (!column.filterType) {
          column.filterType = NO_TYPE;
        } else if (column.filterType === STAR_RATING_TYPE || column.filterType === METRIC_STAR_RATING_TYPE) {
          column.knownValues = STAR_FILTER_VALUES;
        }
        if (filter.treeValueBranchSelect) {
          column.treeValueBranchSelect = filter.treeValueBranchSelect;
        }
        if (filter.filterWidth) {
          column.filterWidth = filter.filterWidth;
        }
        if (filter.knownValuePath) {
          column.knownValuePath = filter.knownValuePath;
        }
        if (filter.knownValues) {
          column.knownValues = filter.knownValues;
        }
        if (filter.displayId || filter.displayField) {
          column.displayField = filter.displayId || filter.displayField;
        }
        if (filter.filterWidth) {
          column.filterWidth = filter.filterWidth;
        }
        if (filter.datasetId) {
          column.datasetId = filter.datasetId;
        }
        if (filter.quickPickId) {
          column.quickPickId = filter.quickPickId;
        }
        columns.push(column);
      });
      return columns;
    // });
  },

  getFilterDisplayStringFromFilterExpression: function(filterExpression) {
    let self = this;
    return self.getFilterStringFromFilterExpression(filterExpression, true, true);
  },

  getFilterStringFromFilterExpression: function(filterExpression, dontEncode, display) {
    let self = this;
    if (_.isArray(filterExpression) && filterExpression.length > 0 && filterExpression[0].criteria) {
      filterExpression = self.convertOldFilters(filterExpression);
    }
    let filterString = '';

    if (filterExpression && filterExpression.filterGroups) {
      // let filterGroups = filterExpression.filterGroups.filter((group) => group.filters.length > 0 && (!!group.filters[0].value || group.filters[0].isQuickPick || group.filters[0].isQuickStart));
      let filterGroups = filterExpression.filterGroups;
      // group all filters if or'd together to fix back end issue where date is ignored
      if (!display && filterExpression.operator === 'or') {
        filterString += '(';
      }
      filterGroups.forEach(function(filterGroup, index) {
        let groupString = convertFilterGroupToString(filterGroup, display);
        if (groupString) {
          if (!display || filterString || index + 1 < filterGroups.length) {
            groupString = '(' + groupString + ')';
          }
          filterString += groupString;
          // add and/or if not last
          if (index + 1 < filterGroups.length) {
            filterString += (filterExpression.operator === 'and' ? (display ? ' and ' : ';') : (display ? ' or ' : ','));
          }
        }
      });

      if (!display && filterExpression.operator === 'or') {
        filterString += ')';
      }
    }
    // remove trailing operator if there (last group was empty)
    if (filterString.charAt(filterString.length - 1) === ',' || filterString.charAt(filterString.length - 1) === ';') {
      filterString = filterString.substring(0, filterString.length - 1);
    }
    // if all filters have been removed remove empty group
    if (filterString === '()') {
      filterString = '';
    }

    return dontEncode ? filterString : encodeURIComponent(filterString);
  },

  filter: function(data, filterExpression) {
    let self = this;
    let result = filterExpression.operator === 'and';
    if (_.isArray(filterExpression) && filterExpression.length > 0 && filterExpression[0].criteria) {
      filterExpression = self.convertOldFilters(filterExpression);
    }

    if (filterExpression && filterExpression.filterGroups) {
      let filterGroups = filterExpression.filterGroups;
      filterGroups.forEach(function(filterGroup, index) {
        let groupResult = self.evaluateGroup(data, filterGroup);

        if (filterExpression.operator === 'or' && groupResult) {
          result = true;
        } else if (filterExpression.operator === 'and' && !groupResult){
          result = false;
        }
      });
    }
    return result;
  },

  evaluateGroup: function(data, filterGroup){
    let self = this;
    let result = filterGroup.operator === 'and';
    _.forEach(filterGroup.filters, function(filter) {
      let filterResult = self.evaluateFilter(data, filter);

      if (filterGroup.operator === 'or' && filterResult) {
        result = true;
      } else if (filterGroup.operator === 'and' && !filterResult){
        result = false;
      }

    });
    return result;
  },

  evaluateFilter: function(data, filter){
    let self = this;

    if (filter.type === 'string') {
      let value = _.get(data, filter.field);

      return filterFunctions[convertOperator(filter.operatorText, filter.type)](filter.queryVar, value, data)

    } else if (filter.type === 'number') {
      let value = data[filter.field]; // todo convert to number?

      return filterFunctions[convertOperator(filter.operatorText, filter.type)](filter.queryVar, value, data)

    } // todo all types

    return true;
  },

  getFiltersFromString: function(filterRsql, metadata) {
    let filterExpression = { filterGroups: []};

    // we can not parse the =in= filter properly or create a display string for it
    // so instead just replace it with something we can parse, then later on
    // replace that well known filter with one we build up from external data
    let tagsInMatch = filterRsql.match(/tags=in=\("([^"]+)=[^"]+"(,\s*"[^"]+")*\)/);
    if (!_.isEmpty(tagsInMatch)) { // todo handle " in the tag name
      filterRsql = filterRsql.replace(tagsInMatch[0], `tags=="${tagsInMatch[1]}=-515"`)
    }

    let filterGroups = getGroupsFromRsql(filterRsql, filterExpression);

    filterGroups.forEach(function(filterGroupRsql, index) {
      if (!filterGroupRsql) {
        return;
      }
      let filters = getTopLevelParenContents(filterGroupRsql);
      let operator = 'and';
      if (filters.length > 1) {
        let rsqlOperator = filterGroupRsql.charAt(filterGroupRsql.indexOf(filters[1]) - 1);
        operator = (rsqlOperator === ';' ? 'and' : 'or');
      }
      filterExpression.filterGroups.push({
        filters: parseFilters(filters, metadata),
        operator: operator,
      });
    });

    return filterExpression;
  },

  getKnownValues: function(knownValuePath) {
    let knownValuePathBreakdown = knownValuePath.split(':');
    let knownValuePathPrefix = knownValuePathBreakdown[0];
    let knownValuePathSuffix = knownValuePathBreakdown[0];
    let baseUrlPromise;
    if (knownValuePathBreakdown.length > 1) {
      knownValuePathSuffix = knownValuePathBreakdown[1];
    }
    if (knownValuePathPrefix === 'dashboard') {
      baseUrlPromise = DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL();
    } else if (knownValuePathPrefix === 'dashboardv2') {
      baseUrlPromise = DataProvider.getInstance().fetchAssuranceDashboardServiceV2BaseURL();
    } else if (knownValuePathPrefix === 'apps') {
      baseUrlPromise = DataProvider.getInstance().fetchAssuranceAppsServiceBaseURL();
    } else {
      baseUrlPromise = DataProvider.getInstance().fetchAssuranceAppsServiceBaseURL();
    }
    return baseUrlPromise.then(baseUrl => {
      return Api.request({
          url: baseUrl + knownValuePathSuffix,
          method: 'GET',
          responseType: 'json'
        })
        .then(response => response.data)
        .then(maybeGroupMultiSelectOptions)
        .catch((error)=> {
          console.error('Failed Request', error);
          throw error;
        });
    });
  },
  fetchTags: function () {
      return DataService
          .fetchEndpointTags()
          .then(maybeGroupMultiSelectOptions);
  },

}

function getMultiSelectOptions(valuesArray) {
  function filterUniqueTree(items, seen = new Set()) {
    let results =  items.map( value => {
      if (value === null) {
        return value;
      }
      if (typeof value === 'object') {
        return value;
      }
      return { id: value, name: value };
    }).filter(item => {
      if (item !== null && !seen.has(item.id)) {
        seen.add(item.id);
        if (item.children) {
          item.children = filterUniqueTree(item.children, seen);
        }
        return true;
      } else if (item) {
        // console.log('excluding duplicate', item);
      }
      return false;
    });
    
    return results;
  }

  return filterUniqueTree(valuesArray);
}

function maybeGroupMultiSelectOptions(valuesArray) {
  const items = getMultiSelectOptions(valuesArray);
  if (items.length > 100) {
    let itemMap = {};
    _.sortBy(items, 'name').forEach( item => {
      if (typeof item.name === 'string' && !itemMap[item.name.charAt(0).toUpperCase()]) {
        itemMap[item.name.charAt(0).toUpperCase()] = [];
      }
      if (typeof item.name === 'string') {
        itemMap[item.name.charAt(0).toUpperCase()].push(item);
      }
    });
    let results = [];
    _.keys(itemMap).forEach(key => {
      if (itemMap[key].length > 4) {
        results.push({id: 'alpha_vy_' + key, name: key, children: itemMap[key]})
      } else {
        itemMap[key].forEach(v => results.push(v));
      }
    });
    return results;
  }
  return items;
}

// gets group strings from rsql string and sets operator on filter expression
function getGroupsFromRsql(rsqlPassed, filterExpression) {
  let rsql = rsqlPassed;
  // strip outer parens if there
  if (rsql.startsWith('(((')) {
    rsql = rsql.substring(1, rsql.length - 1);
  }
  let groups = getTopLevelParenContents(rsql);
  // if this is just a single filter or group
  if (groups.length === 0) {
    groups.push(rsql);
  } else if (groups.length > 1) {
    let rsqlOperator = rsql.charAt(rsql.indexOf(groups[1]) - 2);
    filterExpression.operator = (rsqlOperator === ';' ? 'and' : 'or');
  } else {
    filterExpression.operator = 'and';
  }
  return groups;
}

// takes string and returns array of strings in top level parentheses
function getTopLevelParenContents(source) {
  let groupStart = source.indexOf('(');
  let strings = [];
  let parenCount = 0;
  if (groupStart === -1) {
    return [source];
  }
  for (let i = 0; i < source.length; i ++) {
    let current = source.charAt(i);
    if (current === '(') {
      parenCount++;
    } else if (current === ')') {
      parenCount--;
    }
    if (parenCount === 0 && i > groupStart) {
      let segment = source.substring(groupStart, i + 1); // add one to the end because we're in the same iteration
      // strip outer parens if there
      if (segment.startsWith('((')) {
        segment = stripOuterParens(segment);
      }
      strings.push(segment);
      groupStart = source.indexOf('(', i);
    }
  }
  return strings;
}

function stripOuterParens(source) {
  if (source.startsWith('(')  && source.endsWith(')')) {
    return source.substring(1, source.length - 1);
  }
  return source;
}
